// extracted by mini-css-extract-plugin
export default {"navbar":"mobileNavbar_navbar__HTGVd","menuContainer2":"mobileNavbar_menuContainer2__dupd3"};